import classNames from 'classnames'
import s from './ChoosingOption.module.css'
import { AnswerButton } from '../AnswerButton/AnswerButton'
import JsonPars from '../../../UI/JsonPars/JsonPars'
import { jsonConvert } from '../../../../helpers/jsonConvert'
import { useTaskHomeWork } from '../hooks/useTaskHomeWork'
import {useHistory, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import { formateTime } from '@/helpers/formateTime'
import { useVideoState } from '../hooks/useVideoState'
import { VideoAnswer } from '../VideoAnswer/VideoAnswer'
import { convertAnswer } from './helpers/convertAnswer'

export const ChoosingOption = ({ type,   ...props }) => {
  const correct = jsonConvert(props.correct_answer, 'json')
  if(type == 'decided'){
    return <Decided {...props} />
  }
  if (type == 'correction') {
    return <Correction {...props} />
  }
  if(Number.isInteger(correct) || correct?.length == 1) { 
    return <Task hist={props?.hist}   { ...props} />
  } 
  else {
    return <TaskDZ hist={props?.hist}   { ...props} />
  }
 
}

const Correction = ({ variants }) => {
  return (
    <div className={s.multiChoiceTestContainer}>
      {variants?.map(variant => (
        <button key={variant.index} className={s.btn} disabled={true}>
          <JsonPars json={variant.text} />
        </button>
      ))}
    </div>
  )
}

const Decided = ({ userRole, ...props }) => {
  const { video, videoType } = useVideoState(
          {
              video_source_type: props?.params?.result?.video_source_type,
              video_solution: props?.params?.result?.video_solution,
              video_solution_platform_media: props?.params?.result?.video_solution_platform_media,
              video_solution_iframe: props?.params?.result?.video_solution_iframe
          }
  );

  const answer = props?.params?.result?.answer
  let correctAnswer = props?.params?.result?.correct_answer
  if(!correctAnswer){
    correctAnswer = props?.correct_answer
  }
  const decidedRight = props?.params?.result?.decided_right

  const data = jsonConvert(props.answer_options, 'json')
 
  return <>
    <div className={s.wrapper}>
        <div className={s.cgecingOtv}>Варианты ответа:</div>
        <div className={s.multiChoiceTestContainer}>
          {data?.map((val, i) =>

           <div className={s.cgecingOtv}><span>{i + 1}.</span> <JsonPars json={val.text} /></div>)
            }

        </div>
    </div>
        <div className={s.answerWrap}>

          <span className={classNames(s.capsuleLeft, { [s.red]: decidedRight !== 1 && !props?.hideSolutionCorrectness })}>{userRole === 'children' ? 'Ваш ответ' : 'Ответ ребёнка'}</span>
          <div><span className={s.capsuleRight}>{!!answer ? convertAnswer(answer) : <span className='error'>нет ответа</span>}</span></div>
          {correctAnswer && !props?.hideSolutionCorrectness && <>
            <span className={s.capsuleLeft}>Правильный ответ</span>
            <div><span className={s.capsuleRight}>{convertAnswer(correctAnswer)}</span></div>
          </>}
        </div> 
    {props?.params?.result?.time_spent &&
      <div className={s.estimation}>
        <span className={s.booble}>Потрачено время</span>
        <span className={s.booble}> {formateTime(props?.params?.result?.time_spent)}</span>
      </div>
    }
    {video && <div style={{marginTop: '10px'}}><VideoAnswer video={video} videoType={videoType} /></div>}
  </>
}

const Task = ({ params, hist, userRole,  ...props }) => {
  const data = jsonConvert(props.answer_options, 'json')
  const { onAnswer, answer, status, hint, video, videoType, correctAnswer } = useTaskHomeWork(params,  props )

  return <>
 
    <div className={s.multiChoiceTestContainer}>
      {data?.map((val, i) =>
        <button key={i} onClick={() => { (status < 5 && userRole !== 'parent') && answer.set(val.index) }} className={classNames(s.btn, { [s.disable]: (status > 4 || userRole === 'parent') }, { [s.active]: +answer.get === +val.index })}><JsonPars json={val.text} /></button>)}
    </div>

    {!props?.hideSolutionCorrectness && correctAnswer && hist !== '?redo=ok' && params.type !== 'control' && <div className={s.answerWrapTask}>
      <span className={s.capsuleLeft}>Правильный ответ</span>
      <div><span className={s.capsuleRight}>{convertAnswer(correctAnswer)}</span></div>
    </div>
    }
 
    <AnswerButton hideSolutionCorrectness = {props?.hideSolutionCorrectness} hintForChild={params.hintForChild} hintAfterAllAttempts={props.hint_after_all_attempts} {...{ status, onAnswer, hint, video, videoType }} />
  </>
}

const TaskDZ = ({ params, hist, userRole,  ...props }) => {
  const data = jsonConvert(props.answer_options, 'json')
  const { onAnswer, answer, status, hint, video, videoType, correctAnswer } = useTaskHomeWork(params,  props, undefined, [], true )
  const [arrayAnswer, setArrayAnswer] = useState(answer.get);

  return <>
 
      <div className={s.multiChoiceTestContainer}>
        {data?.map((val, i) =>
          <button key={i} onClick={() => { if(status > 4 || userRole === 'parent') return;
            let arrr = Array.isArray(answer.get)? answer.get: [];
            if (arrr.includes(val.index)) {
                arrr = arrr.filter((el) => el != val.index );
            } else {
                  arrr = arrr.concat(val.index);
            }
            answer.set(arrr);
            setArrayAnswer(arrr);
            }} 
            className={classNames(s.btn, s.btnMulti, { [s.disable]: (status > 4 || userRole === 'parent') },
                { [s.active]: ((Array.isArray(arrayAnswer) && arrayAnswer.includes(val.index)) || +answer.get === +val.index) })}
          >
                <JsonPars json={val.text} /></button>)}
      </div>

    {!props?.hideSolutionCorrectness && correctAnswer && hist !== '?redo=ok' &&   params.type !== 'control'    && <div className={s.answerWrapTask}>
      <span className={s.capsuleLeft}>Правильный ответ</span>
      <div><span className={s.capsuleRight}>{convertAnswer(correctAnswer)}</span></div>
    </div>
    }

    <AnswerButton hideSolutionCorrectness = {props?.hideSolutionCorrectness} hintAfterAllAttempts={props.hint_after_all_attempts} hintForChild={params.hintForChild}  {...{ status, onAnswer, hint, video, videoType  }} />
  </>
}
